/**
 * Full account includes for fetching complete account data
 * Used when we need all relationships loaded (billing, subscriptions, players, etc.)
 */
export const FULL_ACCOUNT_INCLUDES =
	'royalty,plan.partnership,overdue,business_category.parent,billing_info,subscriptions.plan.prices,subscriptions.items,brand_identities,players'
